module.exports = __webpack_public_path__ + "img/menu-mobile.f8e09aae.svg";